import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, options, references } from '@apexdesigner/schema-tools';

export const myUserTask = z
  .object({
    id: z.string().hidden().describe('Unique identifier'),

    userTaskId: z.string().describe('The underlying user task id'),

    referenceNumber: z
      .number()
      .nullable()
      .optional()
      .describe('Human-readable reference number'),

    name: z
      .string()
      .nullable()
      .optional()
      .describe('Optional name for this task'),

    userInterface: z
      .string()
      .nullable()
      .optional()
      .describe('Name of the user interface component to render for this task'),

    status: options([
      { value: 'Active', name: 'Active' },
      { value: 'Paused', name: 'Paused' },
      { value: 'Complete', name: 'Complete' },
      { value: 'Canceled', name: 'Canceled' },
    ])
      .nullable()
      .optional()
      .describe('Current state of this task'),

    data: z
      .unknown()
      .nullable()
      .optional()
      .presentAs('json')
      .describe('In-progress working data for this task'),

    completedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When this task was finished'),

    candidateUserId: z
      .string()
      .nullable()
      .optional()
      .describe(
        'The user who can see this task based on role or direct assignment',
      ),

    createdAt: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When this task was created'),

    updatedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When this task was last updated'),

    roleId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to Role'),

    userId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to User'),

    tokenId: z.uuid().hidden().describe('Foreign key to Token'),

    tenantId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to Tenant'),

    role: references('Role'),

    user: references('User'),

    token: belongsTo('Token'),

    tenant: references('Tenant'),
  })
  .describe(
    'User tasks visible to a specific user, either directly assigned or available through a role assignment.\n\nReplaces the process-engine-library view to expose the tenant partition\ncolumn and apply the Tenant Scoped mixin.',
  )
  .as('MyUserTask');

export { myUserTask as myUserTaskSchema };
